import { Image } from '@valbuild/next';
import SingleImageElement from '../PageElements/SingleImageElement';

export interface PageHeaderProps {
  header: string;
  subheader: string;
  image: Image;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  header,
  subheader,
  image,
}) => {
  return (
    <div className="w-full">
      <div className="flex flex-col tablet:flex-row-reverse justify-between gap-32 tablet:gap-128 mb-128">
        <h1 className="text-lg tablet:text-xl shrink-0">{header}</h1>
        <h2 className="font-respira text-respira-lg tablet:text-respira-xl">
          {subheader}
        </h2>
      </div>
      <SingleImageElement image={image} size="xl" />
    </div>
  );
};

export default PageHeader;
